import { PlatePluginOptions } from '@gpeditor/plate-core';

export const ELEMENT_TODO_LI = 'action_item';

export const DEFAULTS_TODO_LIST: Partial<PlatePluginOptions> = {
  hotkey: ['mod+opt+4', 'mod+shift+4'],
};
